import axios from "@/config/axios";

// initial state
const initialState = () => {
  return {
    integrationsList: [],
    requiredFieldCache: {},
    eventDataCache: {},
    predefinedIntegrations: [],
  };
};

const state = initialState();

const getters = {
  getIntegrationsList: (state) => state.integrationsList,
  getRequiredFields: (state) => (key) => {
    return state.requiredFieldCache[key];
  },
  getEventData: (state) => (key) => {
    return state.eventDataCache[key];
  },
  getPredefinedIntegrations: (state) => {
    return state.predefinedIntegrations;
  },
};

const mutations = {
  setIntegrationsList: (state, data) => {
    state.integrationsList = data;
  },
  resetData: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
  setRequiredFields(state, { key, data }) {
    state.requiredFieldCache[key] = data;
  },
  setEventData(state, { key, data }) {
    state.eventDataCache[key] = data;
  },
  setPredefinedIntegrations(state, data) {
    state.predefinedIntegrations = data;
  },
};

const actions = {
  reset: function (context) {
    context.commit("UserIntegrations/resetData", null, {
      root: true,
    });
  },
  fetchIntegrationsList: async (context) => {
    try {
      context.commit("UserIntegrations/setIntegrationsList", [], {
        root: true,
      });
      const response = await axios.get("/user_integrations/list");
      context.commit(
        "UserIntegrations/setIntegrationsList",
        response.data.data,
        {
          root: true,
        }
      );
    } catch (error) {
      context.commit("UserIntegrations/setIntegrationsList", [], {
        root: true,
      });
    }
  },
  fetchRequiredFieldData: async (context, payload) => {
    const provider = payload.selectedApplication;
    const requestBody = {
      provider,
      field: payload.selectedEvent,
      formData: payload.requiredFields,
    };
    try {
      const response = await axios.post(
        `/integrations/service/get-requiredFields-data/${payload.selectedIntegration}`,
        requestBody
      );
      const data = response?.data || {};
      context.commit("setRequiredFields", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch required field data:", error);
      throw error;
    }
  },
  fetchEventData: async (context, payload) => {
    try {
      const response = await axios.post(
        `/integrations/service/get-event-data`,
        payload
      );
      const data = response?.data || {};
      context.commit("setEventData", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch required field data:", error);
      throw error;
    }
  },
  fetchAllPredefinedIntegrations: async (context) => {
 try {
      const res = await axios.get(
      `/integrations/service/get-all-applications`
    );
      context.commit("setPredefinedIntegrations", res.data);
      return res.data;
    } catch (err) {
      console.error("Failed to fetch integrations", err);
    }
},

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
